(function () {
    'use strict';

    angular
        .module('tikonApp')
        .constant('paginationConstants', {
            'itemsPerPage': 20
        });
})();
